<template>
    <modal
        name="modalWalletDeposit"
        :width="'40%'"
        :height="'auto'"
        :click-to-close="false"
    >
        <form @submit.prevent="saveDeposit">

            <button type="button"
                class="btn btn-danger btn-sm btn-closed"
                @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    Depositar al Monedero – {{ user_name }}
                </h5>
            </div>

            <div class="modal-body">

                <div class="alert alert-success">
                    Saldo actual: <strong>${{ wallet_balance }}</strong>
                </div>

                <div class="form-group">
                    <label>Monto a depositar</label>
                    <input
                        type="number"
                        min="1"
                        class="form-control"
                        v-model="form.amount">
                    <div class="text-danger" v-if="errors.amount">
                        {{ errors.amount[0] }}
                    </div>
                </div>

                <div class="form-group mt-3">
                    <label>Método de pago</label>
                    <select v-model="form.payment_method" class="form-control">
                        <option value="">Seleccione</option>
                        <option value="efectivo">Efectivo</option>
                        <option value="transferencia">Transferencia</option>
                        <option value="tarjeta">Tarjeta</option>
                        <option value="otro">Otro</option>
                    </select>
                </div>

                <div class="form-group mt-3">
                    <label>Comentario (opcional)</label>
                    <textarea class="form-control" v-model="form.description"></textarea>
                </div>

                <div class="mt-4">
                    <hr>
                    <button type="submit" class="btn btn-outline-success float-right">
                        <i class="fas fa-save"></i> Guardar
                    </button>

                    <button type="button" @click="closeModal" class="btn btn-outline-warning float-left">
                        Cancelar
                    </button>
                    <br>
                    <br>
                </div>
            </div>

        </form>
    </modal>
</template>

<script>
import request from "@/services/request";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            wallet_balance: 0,
            user_id: "",
            user_name: "",
            errors: {},

            form: {
                user_id: "",
                amount: "",
                payment_method: "",
                description: ""
            }
        };
    },

    methods: {
        closeModal() {
            this.errors = {};
            this.form = {
                user_id: "",
                amount: "",
                payment_method: "",
                description: ""
            };
            this.$modal.hide("modalWalletDeposit");
        },

        async loadWallet() {
            try {
                let { data } = await request.get(`/wallet/${this.user_id}`);
                this.wallet_balance = data.balance;
            } catch (e) {
                console.log(e);
            }
        },

        async saveDeposit() {
            try {
                let { data } = await request.post("/wallet/deposit", this.form);

                this.successNotification(data.message);
                this.closeModal();

                Event.$emit("event-wallet-updated", { user_id: this.user_id });

            } catch (error) {
                this.errors = await this.errorNotification(error);
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },

    created() {
        Event.$on("event-open-wallet-deposit", async (payload) => {
            this.user_id = payload.user_id;
            this.user_name = payload.user_name ?? "";
            this.form.user_id = payload.user_id;

            await this.loadWallet();

            this.$modal.show("modalWalletDeposit");
        });
    },
};
</script>

<style scoped>
.text-danger {
    font-size: 12px;
}
.alert-info {
    background: #e3f2fd;
}
</style>
